import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import MaterialDatePicker from '../_common/MaterialDatePicker'
import RegularDropdown from '../_common/RegularDropdown'
import moment from 'moment'

import { postForm, fetchDetails, resetForm } from '../../actions'

class EditResident extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      first_name: '',
      last_name: '',
      furigana: '',
      tel: '',
      emergency_tel: '',
      room_no: '',
      birthday: '',
      sex: '',
      wifi_installation_status_text: '',
      wifi_ssid: '',
      wifi_encrypt_key: '',
      memo: ''
    }
  }
  componentDidMount () {
    this._initData()
    this.props.resetForm()
  }
  _initData () {
    const {
      id,
      property_id,
      first_name,
      last_name,
      furigana,
      tel,
      emergency_tel,
      room_no,
      birthday,
      sex,
      wifi_installation_status,
      wifi_ssid,
      wifi_encrypt_key,
      memo
    } = this.props.data
    let wifi_installation_status_text
    switch (wifi_installation_status) {
      case 0:
        wifi_installation_status_text = '未着手'
        break
      case 1:
        wifi_installation_status_text = '工事中'
        break
      case 2:
        wifi_installation_status_text = '完了'
        break
      default:
        wifi_installation_status_text = ''
        break
    }
    this.setState({
      id,
      property_id,
      first_name,
      last_name,
      furigana,
      tel,
      emergency_tel,
      room_no,
      birthday,
      sex,
      wifi_installation_status_text,
      wifi_ssid,
      wifi_encrypt_key,
      memo
    })
  }

  _handleContentChange (key, e) {
    if (key === 'sex') {
      this.setState({ sex: Number(e.target.value) })
    } else {
      this.setState({ [key]: e.target.value })
    }
  }
  _handleBirthdayChange (date) {
    // console.log('e: ', date)
    this.setState({ birthday: date })
  }
  _handleWifiStatusChange = (val) => {
    this.setState({ wifi_installation_status_text: val })
  }

  _handleFormSubmit (e) {
    e.preventDefault()
    if (!this.props.post.loading) {
      const {
        id,
        property_id,
        first_name,
        last_name,
        furigana,
        room_no,
        wifi_installation_status_text,
        wifi_encrypt_key,
        wifi_ssid,
        birthday,
        emergency_tel,
        memo,
        sex,
        tel
      } = this.state
      let wifi_installation_status
      switch (wifi_installation_status_text) {
        case '未着手':
          wifi_installation_status = 0
          break
        case '工事中':
          wifi_installation_status = 1
          break
        case '完了':
          wifi_installation_status = 2
          break
        default:
          wifi_installation_status = 0
          break
      }
      const data = {
        id,
        property_id,
        first_name,
        last_name,
        furigana,
        room_no,
        wifi_installation_status,
        wifi_encrypt_key,
        wifi_ssid,
        birthday: birthday ? moment(birthday).format('YYYY-MM-DD') : null,
        emergency_tel,
        memo,
        sex: Number(sex),
        tel
      }
      const redirect = function () {
        this.props.fetchDetails('residents', this.props.data.id)
      }
      // console.log('data: ', data)
      this.props.postForm('residents', data, redirect.bind(this))
      this.props.save()

    // e.preventDefault()
    // const data = _.omit(this.state, ['image', 'imageURL', 'image_error'])
    // this.props.postForm('owners', this.state.image, data, this.props.data.id, null)
    // this.props.save()
    }
  }

  _renderForm () {
    // if (!this.props.push.loading) {
    return (
      <form onSubmit={ this._handleFormSubmit.bind(this) }>
        <div className="flex input_row">
          <div className="input-group flex column">
            <label className="label required" htmlFor="last_name">姓</label>
            <input
              type="text"
              id="last_name"
              className="small_input"
              placeholder="姓"
              value={this.state.last_name}
              onChange={this._handleContentChange.bind(this, 'last_name')}
              required
            />
          </div>
          <div className="input-group flex column">
            <label className="label required" htmlFor="first_name">名</label>
            <input
              type="text"
              id="first_name"
              className="small_input"
              placeholder="名"
              value={this.state.first_name}
              onChange={this._handleContentChange.bind(this, 'first_name')}
              required
            />
          </div>

        </div>

        <div className="input-group flex column">
          <label className="label" htmlFor="furigana">フリガナ</label>
          <input
            type="text"
            id="furigana"
            className="medium_input"
            placeholder="フリガナ"
            value={this.state.furigana}
            onChange={this._handleContentChange.bind(this, 'furigana')}
            // required
          />
        </div>

        <div className="input-group flex">
          <div className="radio-group radio-group-inline">
            <input
              type="radio"
              name="recipient"
              id="female"
              value={2}
              checked={this.state.sex === 2}
              onChange={this._handleContentChange.bind(this, 'sex')}
            />
            <label htmlFor="female">女</label>
          </div>
          <div className="radio-group radio-group-inline">
            <input
              type="radio"
              name="recipient"
              id="male"
              value={1}
              checked={this.state.sex === 1}
              onChange={this._handleContentChange.bind(this, 'sex')}
            />
            <label htmlFor="male">男</label>
          </div>
        </div>

        <div className="input-group flex column">
          <label className="label" htmlFor="birthday">生年月日</label>
          <MaterialDatePicker
            selectedDate={ this.state.birthday }
            updateDate={this._handleBirthdayChange.bind(this)}
          />
          {/* <input
            type="tel"
            id="birthday"
            className="small_input"
            placeholder="生年月日"
            value={this.state.birthday}
            onChange={this._handleContentChange.bind(this, 'birthday')}
          /> */}
        </div>

        <div className="input-group flex column">
          <label className="label required" htmlFor="tel">電話番号<small>（ハイフンなし）</small></label>
          <input
            type="tel"
            id="tel"
            className="small_input"
            placeholder="電話番号"
            value={this.state.tel}
            onChange={this._handleContentChange.bind(this, 'tel')}
            required
          />
        </div>

        <div className="input-group flex column">
          <label className="label" htmlFor="emergency_tel">緊急連絡先</label>
          <input
            type="tel"
            id="emergency_tel"
            className="small_input"
            placeholder="緊急連絡先"
            value={this.state.emergency_tel}
            onChange={this._handleContentChange.bind(this, 'emergency_tel')}
          />
        </div>

        <div className="input-group flex column">
          <label className="label required" htmlFor="room_no">部屋番号</label>
          <input
            type="text"
            id="room_no"
            className="small_input"
            placeholder="部屋番号"
            value={this.state.room_no}
            onChange={this._handleContentChange.bind(this, 'room_no')}
            required
          />
        </div>

        <div className="input-group flex column">
          <label className="label" htmlFor="wifi_ssid">WIFI 工事状況</label>
          <RegularDropdown
            choices={['未着手', '完了', '工事中']}
            updateTerm={this._handleWifiStatusChange}
            selected={ !this.state.wifi_installation_status_text ? '選択して下さい' : this.state.wifi_installation_status_text }
          />
        </div>

        <div className="input-group flex column">
          <label className="label" htmlFor="wifi_ssid">WIFI SSID</label>
          <input
            type="text"
            id="wifi_ssid"
            className="medium_input"
            placeholder="WIFI SSID"
            value={this.state.wifi_ssid}
            onChange={this._handleContentChange.bind(this, 'wifi_ssid')}
          />
        </div>

        <div className="input-group flex column">
          <label className="label" htmlFor="wifi_encrypt_key">WIFI認証キー</label>
          <input
            type="text"
            id="wifi_encrypt_key"
            className="medium_input"
            placeholder="WIFI認証キー"
            value={this.state.wifi_encrypt_key}
            onChange={this._handleContentChange.bind(this, 'wifi_encrypt_key')}
          />
        </div>

        <div className="input-group flex column">
          <label className="label" htmlFor="title">メモ</label>
          <textarea
            id="name"
            className="large_input"
            value={this.state.memo}
            onChange={this._handleContentChange.bind(this, 'memo')}
          >
          </textarea>
        </div>

        <div className="button_container flex justify-center">
          <button className="btn cancel_btn" type="button" onClick={ this.props.close }>キャンセル</button>
          <button className="btn submit_btn" type="submit">保存</button>
        </div>
      </form>
    )
    // }
    // return <Loader classname="loader_dot_circle"/>
  }

  render () {
    // if (this.props.push && this.props.push.postSuccess) {
    //   return <Redirect to='/push' />
    // }
    return (
      <section className="resident_form add_form">
        <h4 className="page_title bold">入居者追加</h4>
        { this._renderForm() }
      </section>
    )
  }
}

function mapStateToProps ({ user, post }) {
  return { user, post }
}

export default connect(mapStateToProps, { postForm, fetchDetails, resetForm })(EditResident)
// export default AddOwner



// WEBPACK FOOTER //
// ./src/components/Residents/EditResident.js